export default __webpack_public_path__ + "images/B2.d47f2e9.png";